import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=5bc13413"
import script from "./LayoutPage.vue?vue&type=script&lang=ts"
export * from "./LayoutPage.vue?vue&type=script&lang=ts"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=5bc13413&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc13413')) {
      api.createRecord('5bc13413', component.options)
    } else {
      api.reload('5bc13413', component.options)
    }
    module.hot.accept("./LayoutPage.vue?vue&type=template&id=5bc13413", function () {
      api.rerender('5bc13413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/layout/LayoutPage.vue"
export default component.exports